import React from 'react';
import { Clearfix, Media, Tooltip, OverlayTrigger } from 'react-bootstrap';

export function createStatusElement({ status, status_msg }, { onClick }) {
    if (!status) return;

    const tooltip = status_msg ? <Tooltip>{status_msg}</Tooltip> : null;
    let iconClz = 'icon icon-status icon-' + (status === 'loading' ? status : 'resend');

    return (
        <OverlayTrigger overlay={tooltip}>
          {
            status==='loading' ?
            <i className={iconClz}></i> :
            <a className={iconClz} onClick={onClick}></a>
          }
        </OverlayTrigger>
    );
}

export function createElement({ props, Left, Right, Heading, Content, Status }) {
    return (
        <Media {...props}>
          {Left ? <Media.Left>{Left}</Media.Left> : null}
          <Media.Body>
            {Heading ? <Media.Heading>{Heading}</Media.Heading> : null}
            <Clearfix className="msg-content">
              {Status}
              {Content}
            </Clearfix>
          </Media.Body>
          {Right ? <Media.Right>{Right}</Media.Right> : null}
        </Media>
    );
}


// WEBPACK FOOTER //
// ./src/msg/item/base.js